// extracted by mini-css-extract-plugin
export default {"image":"Img_image__kPLLw"};